document.addEventListener("DOMContentLoaded", function () {
    const postThumbnail = document.querySelector(".contact-page__image");
    const formationRightCol = document.querySelector(".contact-page__right");

    if (postThumbnail) {

        if (window.innerWidth > 991) {

            let is_sticky = false;

            const positionFixed = postThumbnail.getBoundingClientRect().top + window.scrollY;
            const postThumbnailHeight = postThumbnail.offsetHeight;

            const breadcrumbHeight = document.querySelector(".breadcrumb").offsetHeight;
            const container = document.querySelector(".contact-page__content");
            const containerHeight = container.offsetHeight;

            document.addEventListener("scroll", function () {

                const siteHeader = document.querySelector(".site-header.site-header--sticky");
                const siteHeaderHeight = siteHeader.offsetHeight + 25;
                const fullHeight =  breadcrumbHeight + containerHeight + siteHeaderHeight;

                if (window.scrollY + siteHeaderHeight + postThumbnailHeight - fullHeight > 0) {
                    postThumbnail.classList.remove("is-fixed");
                    postThumbnail.classList.add("position-fixed-footer");
                    is_sticky = false;
                }

                if (!is_sticky && positionFixed <= window.scrollY + siteHeaderHeight && window.scrollY + siteHeaderHeight + postThumbnailHeight - fullHeight < 0) {
                    postThumbnail.classList.add("position-fixed");
                    postThumbnail.classList.remove("position-fixed-footer");

                    if (formationRightCol) {
                        formationRightCol.style.position = "relative";
                    }

                    is_sticky = true;

                } else if (is_sticky && positionFixed > window.scrollY + siteHeaderHeight) {
                    postThumbnail.classList.remove("position-fixed");
                    is_sticky = false;
                }

            });
        }
    }
})